import type { TransitionStyle } from '../types';

export function CharacterTransition({ style, sequence }: { style: TransitionStyle; sequence: number }) {
  return <div key={sequence} className={`character-transition character-transition--${style}`} aria-hidden="true"><i /><b /></div>;
}
